import { AppState } from "app/shared/store/root.reducer";
import { createSelector } from "reselect";

const getStore = (state: AppState) => state.transfer247;
const getDataCreate = (state: AppState) => state.transfer247.dataCreate;
const getAccountCredit = (state: AppState) => state.transfer247.accountCredit;
const getResponseMakeFee = (state: AppState) => state.transfer247.responseMakeFee;
const getResponseCreated = (state: AppState) => state.transfer247.responseCreate;
const getResponseConfirm = (state: AppState) => state.transfer247.responseConfirm;
const getResponseAuth = (state: AppState) => state.transfer247.responseAuth;
const getStatusAccountCredit = (state: AppState) => state.transfer247.statusAccountCredit;
export const getTransfer247StoreSelector = createSelector(getStore, (data) => data);
export const getTransfer247DataCreateSelector = createSelector(getDataCreate, (data) => data);
export const getTransfer247AccountCreditSelector = createSelector(getAccountCredit, (account) => account);
export const getTransfer247StatusAccountCreditSelector = createSelector(getStatusAccountCredit, (state) => state);

export const getTransfer247MakeFeeSelector = createSelector(getResponseMakeFee, (fee) => fee);

export const getTransfer247ResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTransfer247ResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTransfer247ResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
